import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MachadaloStudioDashboard from './ComapnyForm.tsx';
import Ai from './Ai.tsx';
import InstructionSetForm from './InstructionSet.tsx';
import QueryHistoryDashboard from './QueryHistoryDashboard.tsx';
import AvatarCreator from './AvatarCreator.tsx';

const MachadaloStudio = () => {
  return (
    <Routes>
      <Route path="companyform" element={<MachadaloStudioDashboard />} />
      <Route path="ai" element={<Ai />} />
      <Route path="instructionsetform" element={<InstructionSetForm />} />
      <Route path="history" element={<QueryHistoryDashboard />} />
      <Route path="avatar-create" element={<AvatarCreator />} />
    </Routes>
  );
};
export default MachadaloStudio;
